<template>
  <div>
    <div class="row" v-if="!isThongTin">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="card mx-auto mt-3">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.stop.prevent="handleSubmit(btnSearch)">
              <div class="card-body">
                <div class="card-title">
                  {{ $t("models.dieuChinh.title") }} 
                  <span class="text-danger"> ( {{ $t("models.dieuChinh.noteDieuChinh") }} ) </span>
                </div>                
                <div class="form-group">
                  <label for="txtSoCMND">
                    {{ $t("models.thiSinh.cmnd") }}:
                  </label>
                  <validation-provider
                    :name="$t('models.thiSinh.cmnd')"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <input
                      type="text"
                      id="txtSoCMND"
                      class="form-control"
                      v-model="thongtin.soCmnd"
                      :placeholder="$t('message.title.nhapSoCmnd')"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="form-group">
                  <label for="txtRegCode">
                    {{ $t("models.dieuChinh.regCode") }}:
                  </label>
                  <validation-provider
                    :name="$t('models.dieuChinh.regCode')"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <input
                      type="number"
                      id="txtRegCode"
                      class="form-control"
                      v-model="thongtin.regCode"
                      :placeholder="$t('message.title.nhapMaDk')"
                      :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </validation-provider>
                </div>                
                <div class="mt-2 text-center">
                  <button class="btn btn-primary" id="btnSearch">
                    Tra cứu
                  </button>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
    <thong-tin-dang-ky
      v-if="isThongTin"
      :isThongTin="isThongTin"
      @changeIsThongTin="isThongTin = false"
      screenAction="ChinhSua"
    ></thong-tin-dang-ky>
    <!-- <thong-tin-dieu-chinh
			v-if="isThongTin"
			:isThongTin="isThongTin"
			@changeIsThongTin="isThongTin = false"
		></thong-tin-dieu-chinh> -->
  </div>
</template>

<script>
import DieuChinh from "../js/dieuchinh";
export default DieuChinh;
</script>

<style scoped></style>
